import { Form, Select } from 'antd';
import { useMemo } from 'react';

import {
  DEFAULT_CHANNEL_INDEX,
  LAST_INTEGRATION_PROP,
  RULES_IS_REQUIRE,
} from '@app/constants';
import type { NSendoutsApi } from '@app/services/rtkQuery/Sendouts/types';

import type { FC } from 'react';

type Option = {
  value: string;
  label: string;
};

interface Props {
  prepareSendoutCreation: NSendoutsApi.PrepareSendoutCreationResponse | null;
}

const { useFormInstance } = Form;

export const ChannelSelect: FC<Props> = ({ prepareSendoutCreation }) => {
  const form = useFormInstance();
  const channels = useMemo(() => {
    const options: Option[] = prepareSendoutCreation?.Channels
      ? prepareSendoutCreation.Channels.map(({ IdS, Name }) => ({
          value: IdS,
          label: Name,
        }))
      : [];
    options.push({
      value: DEFAULT_CHANNEL_INDEX,
      label: 'Последний активный канал',
    });
    return options;
  }, [prepareSendoutCreation]);

  const onChange = (value: string) => {
    if (value === DEFAULT_CHANNEL_INDEX) {
      form.setFieldsValue({
        integration: LAST_INTEGRATION_PROP,
      });

      return;
    }

    form.setFieldsValue({
      channel: value,
      integration: undefined,
    });
  };

  return (
    <Form.Item
      wrapperCol={{ offset: 4, span: 32 }}
      label="Канал"
      colon
      name="channel"
      initialValue={DEFAULT_CHANNEL_INDEX}
      rules={[...RULES_IS_REQUIRE]}
    >
      <Select
        placeholder="Выберите канал связи"
        value={form.getFieldValue('channel')}
        options={channels}
        style={{ width: '100%' }}
        onChange={onChange}
      />
    </Form.Item>
  );
};
